import { team } from '../../content/team.js';
import { RiseCard } from '../RiseCard/RiseCard.js';

function initials(name: string): string {
  return name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}

export function TeamSection() {
  return (
    <section
      id="team"
      style={{
        maxWidth: '1180px',
        margin: '0 auto',
        padding: 'clamp(46px,7vw,72px) clamp(18px,5vw,64px) 0',
      }}
    >
      <div
        style={{
          font: "700 11.5px/1 'Plus Jakarta Sans',sans-serif",
          letterSpacing: '.09em',
          color: 'var(--faint)',
          textTransform: 'uppercase',
          marginBottom: '14px',
        }}
      >
        {team.eyebrow}
      </div>
      <h2
        style={{
          margin: '0 0 28px',
          maxWidth: '22ch',
          font: "800 clamp(26px,3.4vw,38px)/1.12 'Plus Jakarta Sans',sans-serif",
          letterSpacing: '-.03em',
          color: 'var(--ink)',
        }}
      >
        {team.title}
      </h2>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%,220px), 1fr))',
          gap: '15px',
        }}
      >
        {team.members.map((member, index) => (
          <RiseCard key={member.name} index={index} style={{ textAlign: 'center' }}>
            <div
              style={{
                width: '56px',
                height: '56px',
                margin: '0 auto',
                borderRadius: '999px',
                background: 'var(--yGlass)',
                border: '1px solid var(--yEdge)',
                display: 'grid',
                placeItems: 'center',
                font: "800 15px/1 'Plus Jakarta Sans',sans-serif",
                color: 'var(--yellow)',
              }}
            >
              {initials(member.name)}
            </div>
            <div
              style={{
                marginTop: '14px',
                font: "700 15px/1.3 'Plus Jakarta Sans',sans-serif",
                color: 'var(--ink)',
              }}
            >
              {member.name}
            </div>
            <div
              style={{
                marginTop: '4px',
                font: "600 12.5px/1.4 'Plus Jakarta Sans',sans-serif",
                color: 'var(--faint)',
              }}
            >
              {member.role}
            </div>
          </RiseCard>
        ))}
      </div>
    </section>
  );
}
